import React from 'react';
import TaskSectionPage from '../components/TaskSectionPage';

const Writing: React.FC = () => {
  return (
    <TaskSectionPage
      section="writing"
      title="Writing"
      description="Develop your writing skills with guided exercises and creative prompts."
    />
  );
};

export default Writing;